import { render, staticRenderFns } from "./notiSmsForm.vue?vue&type=template&id=a90c1122&scoped=true"
import script from "./notiSmsForm.vue?vue&type=script&lang=js"
export * from "./notiSmsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90c1122",
  null
  
)

export default component.exports